<template>
    <div class="column is-2 box-shadow-v has-background-greyBG">
        <div class="is-inline-flex has-text-primary p-2">
            <h6 class="is-subtitle-size is-primary pl-3 mr-4">
                {{ $t("conference.historical") }}
            </h6>
            <Icon family="fal" name="fa-history" />
        </div>
        <div class="historical-container mt-2 px-2">
            <ul v-if="!haveEvents" class="font-14">
                <li class="has-text-greyText p-1">
                    {{ $t("historical.empty") }}
                </li>
            </ul>
            <ul v-else class="font-14">
                <li
                    v-for="event in events"
                    :key="event.id"
                    class="has-text-greyText p-1"
                >
                    {{ event.hour }} {{ event.message }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "historical",
    computed: {
        ...mapGetters("historical", ["getEvents"]),
        haveEvents() {
            let events = this.events;
            return events.length > 0;
        },
        events() {
            let events = this.getEvents;
            return events;
        },
    },
};
</script>

<style lang="scss" scoped>
.historical-container {
    max-height: 82vh;
    overflow-y: auto;
}
</style>